import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { openExternalUrl } from '@/adapters/browser/openExternalUrl';
import { ConfirmDialog } from '@/components/atoms/dialog';
import { PRIVACY_POLICY_URL } from '@/constants/externalUrls';
import { useTranslation } from '@/i18n';
import { spacing, unisonColors } from '@/theme';

interface AiTranscriptionConsentDialogProps {
  readonly visible: boolean;
  readonly onAgree: () => void;
  readonly onDecline: () => void;
}

const AiTranscriptionConsentNote = () => {
  const { t } = useTranslation();

  const handlePrivacyPolicyPress = () => {
    void openExternalUrl(PRIVACY_POLICY_URL);
  };

  return (
    <View style={styles.contentBody}>
      <Text variant="bodyMedium" style={styles.bodyText}>
        {t('aiTranscriptionConsent.intro')}
      </Text>
      <View style={styles.bulletList}>
        <Text variant="bodyMedium" style={styles.bodyText}>
          {t('aiTranscriptionConsent.bulletSentData')}
        </Text>
        <Text variant="bodyMedium" style={styles.bodyText}>
          {t('aiTranscriptionConsent.bulletDestination')}
        </Text>
        <Text variant="bodyMedium" style={styles.bodyText}>
          {t('aiTranscriptionConsent.bulletPurpose')}
        </Text>
      </View>
      <Text variant="bodyMedium" style={styles.bodyText}>
        {t('aiTranscriptionConsent.declineConsequence')}
      </Text>
      <Text variant="bodyMedium" style={styles.bodyText}>
        {t('aiTranscriptionConsent.privacyPrefix')}{' '}
        <Text
          onPress={handlePrivacyPolicyPress}
          style={styles.link}
          testID="ai-transcription-consent-privacy-policy">
          {t('aiTranscriptionConsent.privacyLink')}
        </Text>
        {t('aiTranscriptionConsent.privacySuffix')}
      </Text>
    </View>
  );
};

export const AiTranscriptionConsentDialog = ({
  visible,
  onAgree,
  onDecline,
}: AiTranscriptionConsentDialogProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmDialog
      visible={visible}
      title={t('aiTranscriptionConsent.title')}
      body=""
      note={<AiTranscriptionConsentNote />}
      confirmLabel={t('aiTranscriptionConsent.agree')}
      dismissLabel={t('aiTranscriptionConsent.decline')}
      onConfirm={onAgree}
      onDismiss={onDecline}
      testID="ai-transcription-consent-dialog"
    />
  );
};

const styles = StyleSheet.create({
  contentBody: {
    gap: spacing[2],
  },
  bodyText: {
    color: unisonColors.textNdSecondary,
  },
  bulletList: {
    gap: spacing[1],
  },
  link: {
    color: unisonColors.onInfoContainer,
    textDecorationLine: 'underline',
  },
});
